import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import HomeView from "../views/HomeView.vue";
// import AuthView from "../views/AuthView.vue";
// import NewsView from "../views/NewsView.vue";
// import LogView from "../views/LogView.vue";
// import JobView from "../views/JobView.vue";
// import FxSimView from "../views/FxSimView.vue";
// import SingleStatisticView from "../views/SingleStatisticView.vue";
// import MarketView from "../views/MarketView.vue";
// import TrChartView from "../views/TrChartView.vue";
// import PlotlyChartView from "../views/PlotlyChartView.vue";
// import SimulationView from "../views/SimulationView.vue";
import { useUserStore } from "../store/user-store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    //component: HomeView,
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/auth",
    name: "auth",
    //component: AuthView,
    component: () => import("../views/AuthView.vue"),
  },
  {
    path: "/news",
    name: "news",
    //component: NewsView,
    component: () => import("../views/NewsView.vue"),
  },
  {
    path: "/fxchart",
    name: "fxchart",
    //component: FxSimView,
    component: () => import("../views/FxSimView.vue"),
  },
  {
    path: "/market",
    name: "market",
    //component: MarketView,
    component: () => import("../views/MarketView.vue"),
  },
  {
    path: "/trchart",
    name: "trchart",
    //component: TrChartView,
    component: () => import("../views/TrChartView.vue"),
  },
  {
    path: "/log",
    name: "log",
    //component: LogView,
    component: () => import("../views/LogView.vue"),
  },
  {
    path: "/job",
    name: "job",
    //component: JobView,
    component: () => import("../views/JobView.vue"),
  },
  {
    path: "/plotlychart",
    name: "plotlychart",
    //component: PlotlyChartView,
    component: () => import("../views/PlotlyChartView.vue"),
  },
  {
    path: "/simulation",
    name: "simulation",
    //component: SimulationView,
    component: () => import("../views/SimulationView.vue"),
  },
  {
    path: "/simsingle",
    name: "simsingle",
    //component: SingleStatisticView,
    component: () => import("../views/SingleStatisticView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.afterEach((to, from) => {
  // 遷移時はログイン状況を常にチェック
  console.log("from", from.path);
  console.log("to", to.path);
  const userStore = useUserStore();
  userStore.getUserInfo();
  userStore.checkAllowNotification();
});

export default router;
